import { useCallback, useRef } from "react";
import { t } from "../../../../i18n";



export const mapFrequencyNameToTranslation = (frequency?: string) => {
  switch (frequency) {
    case "Daily":
      return t("cashback.cashbackTitle.Daily");
    case "Weekly":
      return t("cashback.cashbackTitle.Weekly");
    case "Monthly":
      return t("cashback.cashbackTitle.Monthly");
    default:
      return t("cashback.cashbackTitle.Default");
  }
};

export const useFetchWithLimit = (callback: () => void, maxCalls: number, timeLimitMs: number) => {
  const callCount = useRef(0);
  const lastResetTime = useRef(Date.now());

  const limitedCallback = useCallback(() => {
      const now = Date.now();

      if (now - lastResetTime.current > timeLimitMs) {
          callCount.current = 0;
          lastResetTime.current = now;
      }

      if (callCount.current < maxCalls) {
          callCount.current++;
          callback();
      }
  }, [callback, maxCalls, timeLimitMs]);

  return limitedCallback;
};